import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
  },
  contentWrapper: {
    width: 'calc(100% - 280px)',
  },
  content: {
    height: 'calc(100vh - 128px)',
    overflow: 'auto',
  },
  contentBody: {
    padding: theme.spacing(0, 5, 4, 5),
  },
  statusBar: {
    padding: theme.spacing(4, 5, 0, 5),
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    position: 'sticky',
    zIndex: 105,
    top: 0,
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  appTitleHeadingText: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    color: theme.palette.labraText.primary,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
  },
  title: {
    alignItems: 'flex-start',
    fontWeight: 400,
    fontSize: '22px',
    lineHeight: '28px',
    color: theme.palette.labraText.primary,
    padding: theme.spacing(4, 5),
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  formDisabled: {
    zIndex: 100,
    position: 'relative',
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  disableEvents: {
    pointerEvents: 'none',
  },
  modalText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
  },
  nameBoldText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px !important',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  SFListingBanner: {
    background: '#FFEEA7',
    height: 'auto',
    gap: theme.spacing(1.25),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(1, 5),
    zIndex: 1000,
  },
  SFListingBannerText: {
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
    letterSpacing: '0.1px',
    fontWeight: 500,
    fontFamily: 'Poppins',
    color: theme.palette.textField.dark,
  },
  errorSubContent: {
    marginTop: theme.spacing(-0.5),
  },
  errorMsg: {
    margin: theme.spacing(-0.5, 0, 1.5, 0),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
  },
  middleSectionContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  contentWrapperFullWidth: {
    width: '100%',
  },
}))
